if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.variantIdInput = this.form.querySelector('[name=id]');
      if (this.variantIdInput) this.variantIdInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText =
        this.submitButton && this.submitButton.querySelector('span');

      if (document.querySelector('cart-drawer'))
        this.submitButton?.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      // === Varianta activă ===
      this.onVariantChange = this.onVariantChange.bind(this);
      if (this.variantIdInput) {
        this.variantIdInput.addEventListener('change', this.onVariantChange);
        document.addEventListener('variant:change', (evt) => {
          const variant = evt?.detail?.variant;
          if (
            variant &&
            String(variant.id) !== String(this.variantIdInput.value)
          ) {
            this.variantIdInput.value = variant.id;
            this.onVariantChange();
          }
        });
      }
      this.onVariantChange();
    }

    // === Actualizare preț și sincronizare variantă ===
    onVariantChange() {
      const variantId = this.variantIdInput ? this.variantIdInput.value : null;
      const variants = window?.Shopify?.product?.variants || [];
      const variant = variants.find(
        (v) => String(v.id) === String(variantId)
      );

      if (variant && this.variantIdInput) {
        this.variantIdInput.value = variant.id;
      }

      if (variant) {
        const priceContainer = document.querySelector('[id^="price-"]');
        if (priceContainer) {
          const priceEl =
            priceContainer.querySelector('.price-item--regular') ||
            priceContainer.querySelector('.price-item--sale') ||
            priceContainer.querySelector('.price-item');
          if (priceEl) {
            const formattedPrice = (variant.price / 100).toLocaleString(
              'ro-RO',
              { style: 'currency', currency: 'RON' }
            );
            priceEl.textContent = formattedPrice;
          }
        }

        const ecoBtn = document.querySelector('.add-to-ecovik-btn');
        if (ecoBtn)
          ecoBtn.setAttribute('data-price', (variant.price / 100).toFixed(2));
      }
    }

    toggleSubmitButton(disable = true) {
      if (!this.submitButton) return;
      this.submitButton.setAttribute('aria-disabled', disable);
    }

    // === Gestionare submit ===
    onSubmitHandler(evt) {
      evt.preventDefault();

      try {
        const variantScript = this.closest('section, product-info, .product, body')
          ?.querySelector('script[data-selected-variant]');
        if (variantScript) {
          const variantData = JSON.parse(variantScript.textContent.trim());
          if (variantData && variantData.id && this.variantIdInput) {
            this.variantIdInput.value = variantData.id;
            console.log('Variantă sincronizată:', variantData.id);
          }
        }
      } catch (err) {
        console.warn('Nu s-a putut actualiza varianta activă:', err);
      }

      if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();

      this.submitButton?.setAttribute('aria-disabled', true);
      this.submitButton?.classList.add('loading');
      this.submitButton
        ?.querySelector('.loading-overlay__spinner')
        ?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.cart.renderContents(response);
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton?.classList.remove('loading');
          this.submitButton
            ?.querySelector('.loading-overlay__spinner')
            ?.classList.add('hidden');
          this.submitButton?.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper?.querySelector(
          '.product-form__error-message'
        );

      this.errorMessageWrapper?.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('product-form')) {
      customElements.define('product-form', ProductForm);
    }

    // === Backup: sincronizare la click pe radio variantă ===
    document.addEventListener('change', (evt) => {
      const target = evt.target;
      if (target.matches('input[type="radio"][name^="Continut"]')) {
        try {
          const form =
            target.closest('product-form') ||
            document.querySelector('product-form');
          const variantScript = target
            .closest('variant-selects')
            ?.querySelector('script[data-selected-variant]');
          if (form && form.querySelector('[name="id"]') && variantScript) {
            const variantData = JSON.parse(variantScript.textContent.trim());
            if (variantData?.id) {
              const idInput = form.querySelector('[name="id"]');
              idInput.value = variantData.id;
              console.log('Sincronizare automată variantă:', variantData.id);
            }
          }
        } catch (e) {
          console.warn('Nu s-a putut sincroniza varianta activă:', e);
        }
      }
    });
  });
}
// === Patch suplimentar: sincronizare globală a tuturor formularelor ===
document.addEventListener('variant:change', (evt) => {
  const variant = evt?.detail?.variant;
  if (!variant?.id) return;

  // actualizăm toate formularele din pagină care au un câmp [name="id"]
  document.querySelectorAll('form[action*="cart/add"] [name="id"]').forEach(input => {
    input.value = variant.id;
  });

  console.log("🔁 Toate formularele actualizate cu varianta:", variant.id);
});

